import { BaseEntity } from '@/types';

export enum USER_STATUS {
  A = 'ACTIVE',
  C = 'CONFIRMED',
  D = 'CANCELED',
}

export type User = {
  name: string;
  email: string;
  status: string;
  /** 0 | 1 */
  email_confirmed: number;
} & BaseEntity;

export type AdminProfileDTO = {
  data: {
    name: string;
    country_code: string;
    email: string;
    phone: string;
  };
};

export type ContributorDTO = {
  data: {
    name: string;
    email: string;
    /** should included from API */
    status?: string;
    role_id: number;
  };
};

export type ChangePasswordDTO = {
  data: {
    newPassword: string;
    confirmNewPassword: string;
  };
};

export type AddGroupDTO = {
  // TODO define how to use addresses
  data: {
    name: string;
    country_code: string;
    // TODO add phone number field
    // phone: string;
  };
};

export type UserProfileDTO = {
  data: {
    name: string;
    country_code: string;
    email: string;
    phone: string;
    notifications: boolean;
  };
};
